import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'at-header-message',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './header-message.component.html',
  styleUrl: './header-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMessageComponent {
  public message = input.required<string>();
  public actionLabel = input<string>();
  public actionLink = input<string>();
  public actionFn = input<() => void>();
}
